/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-07-16 18:19:18
 * @LastEditTime: 2019-09-09 18:41:05
 * @LastEditors: yingbin
 */
import Vue from 'vue';
import axios from 'axios';
import utils from './utils'
import store from '@/stores/index'
axios.defaults.timeout = 20000;

function checkStatus(response) {
	// 如果http状态码正常，则直接返回数据
	if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
		return response.data
	}else{
		console.log(response)
	}
	// return {
	// 	status: 'error',
	// 	// msg: '网络波动，请稍后再试'
    //     msg:response.data
	// }
}

class Request {
	/** post请求 */
	post(self, data) {
		if (data.action == 'common.getimgcode' || data.action == 'user.retrievepwd') {
			sessionStorage.setItem("req_time", new Date().getTime())
		}
		return new Promise((resolve, reject) => {
			axios({
				url:'/openapi-interface' +data.url,
				method: "post",
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'Content-Type': 'application/json; charset=utf-8'
				},
				data: {
					"action": data.action,
					"appid": "g7r6lo3qji4ue8rx",
					"appver": "6.0.0.02",
					"data": data.data || {},
					"req_time": new Date().getTime(),
					"version": "V1.0",
				}
			}).then(res => {
				if (checkStatus(res).true) {
					if (checkStatus(res).code == 20001 || checkStatus(res).code == 20002 || checkStatus(res).code == 20003 || checkStatus(res).code == 20004) {
						utils.setCookie("TOKEN","")
						utils.setCookie("USER_INFO","")
						utils.removeCookie("TOKEN")
						utils.removeCookie("USER_INFO")
						store.commit("USER_INFO", '');
						setTimeout(() => {
							Vue.prototype.$toast(true)
						}, 500);
					}
					resolve(checkStatus(res))
				} else {
					if (checkStatus(res).code == 20001 || checkStatus(res).code == 20002 || checkStatus(res).code == 20003 || checkStatus(res).code == 20004) {
						utils.setCookie("TOKEN","")
						utils.setCookie("USER_INFO","")
						utils.removeCookie("TOKEN")
						utils.removeCookie("USER_INFO")
						store.commit("USER_INFO", '');
						setTimeout(() => {
							Vue.prototype.$toast(true)
						}, 500);
					}
					// self.$message.error(res.data.message);
					if(self.changeCode){
						// 如何有切换验证码的方法，则执行
						self.changeCode()
					}
					resolve(checkStatus(res))
				}
			}).catch(err => {
				// self.$message.error("服务器维护，请稍后再试！");
				console.log(err)
				reject(err);
			})
		});
	}
}

export default new Request()